/* ================================================================
   HALDEN HOUSE — UI Interactions
   Scroll Reveal · Announcement Rotator · Sticky ATC
   ================================================================ */

(function () {
  'use strict';

  /* ---- Scroll Reveal ---- */
  function initReveal() {
    const els = document.querySelectorAll('.hh-reveal');
    if (!els.length) return;

    const revealAll = () => els.forEach((el) => el.classList.add('hh-visible'));

    /* If IntersectionObserver isn't available, just show everything */
    if (!('IntersectionObserver' in window)) { revealAll(); return; }

    /* Opt into the hidden-then-animate behaviour only now that JS is running */
    document.body.classList.add('hh-js');

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            const delay = e.target.dataset.hhDelay || 0;
            setTimeout(() => e.target.classList.add('hh-visible'), Number(delay));
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    els.forEach((el) => io.observe(el));

    /* Fail-safe: anything still hidden after 3s gets revealed regardless */
    setTimeout(revealAll, 3000);
  }

  /* ---- Announcement Bar Rotator ---- */
  function initAnnouncement() {
    const bars = document.querySelectorAll('[data-hh-announce]');
    bars.forEach((bar) => {
      const items = bar.querySelectorAll('[data-hh-announce-item]');
      if (items.length < 2) return;
      let idx = 0;
      const speed = Number(bar.dataset.hhSpeed || 4000);

      items.forEach((item, i) => {
        item.style.transition = 'opacity 500ms ease, transform 500ms ease';
        if (i !== 0) {
          item.style.opacity = '0';
          item.style.position = 'absolute';
          item.style.inset = '0';
          item.style.display = 'flex';
          item.style.alignItems = 'center';
          item.style.justifyContent = 'center';
        }
      });

      setInterval(() => {
        const prev = items[idx];
        idx = (idx + 1) % items.length;
        const next = items[idx];

        prev.style.opacity = '0';
        prev.style.transform = 'translateY(-8px)';
        setTimeout(() => {
          prev.style.position = 'absolute';
          next.style.position = 'relative';
          next.style.transform = 'translateY(8px)';
          requestAnimationFrame(() => {
            next.style.opacity = '1';
            next.style.transform = 'translateY(0)';
          });
        }, 300);
      }, speed);
    });
  }

  /* ---- Sticky ATC ---- */
  function initStickyATC() {
    /* If no explicit anchor, auto-assign it to the product form wrapper */
    let anchor = document.querySelector('[data-hh-atc-anchor]');
    if (!anchor) {
      anchor = document.querySelector('.product-form, product-form, #product-form, [data-product-form]');
      if (anchor) anchor.setAttribute('data-hh-atc-anchor', '');
    }

    const bar = document.querySelector('[data-hh-sticky-atc]');
    if (!anchor || !bar) return;

    const io = new IntersectionObserver(
      ([entry]) => {
        bar.classList.toggle('hh-sticky-atc--visible', !entry.isIntersecting);
      },
      { rootMargin: '0px 0px -80px 0px' }
    );
    io.observe(anchor);

    /* forward click to original add-to-cart — search anchor then document */
    const stickyBtn = bar.querySelector('[data-hh-sticky-atc-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        const originalBtn =
          anchor.querySelector('[name="add"], .product-form__submit, [data-hh-atc-btn]') ||
          document.querySelector('[name="add"], .product-form__submit, [data-hh-atc-btn]');
        if (originalBtn) {
          originalBtn.click();
          anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }
  }

  /* ---- Collection Tiles hover parallax (light) ---- */
  function initTileParallax() {
    const tiles = document.querySelectorAll('.hh-tile');
    tiles.forEach((tile) => {
      const img = tile.querySelector('.hh-tile__img');
      if (!img || window.matchMedia('(max-width: 749px)').matches) return;

      tile.addEventListener('mouseenter', () => {
        img.style.transition = 'transform 800ms cubic-bezier(0.25,0.46,0.45,0.94)';
        img.style.transform = 'scale(1.06)';
      });
      tile.addEventListener('mouseleave', () => {
        img.style.transform = 'scale(1)';
      });
    });
  }

  /* ---- Reviews horizontal drag scroll ---- */
  function initReviewsDrag() {
    const track = document.querySelector('.hh-reviews__track');
    if (!track) return;

    let isDown = false, startX, scrollLeft;

    track.addEventListener('mousedown', (e) => {
      isDown = true;
      track.classList.add('is-dragging');
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });
    track.addEventListener('mouseleave', () => { isDown = false; track.classList.remove('is-dragging'); });
    track.addEventListener('mouseup', () => { isDown = false; track.classList.remove('is-dragging'); });
    track.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX) * 1.5;
      track.scrollLeft = scrollLeft - walk;
    });
  }

  /* ---- Init All ---- */
  function init() {
    initReveal();
    initAnnouncement();
    initStickyATC();
    initTileParallax();
    initReviewsDrag();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
